/* Fioridella — UJ-03: fecha de entrega con corte, en la ficha de producto.
   Reglas (D37): L-V corte 1:00 PM, sabado 2:00 PM, domingo cerrado.
   Zona horaria America/Puerto_Rico (AST, sin cambio de hora).
   La logica de fechas es pura (FDDate) para probarse con hora inyectada
   (node implementation/uj03-producto/test_corte.js); el DOM se engancha aparte.
   Hora inyectada en navegador: ?fd_now=YYYY-MM-DDTHH:MM (se lee como hora de PR). */

var FDDate = (function () {
  'use strict';

  var TZ = 'America/Puerto_Rico';
  var SUNDAY = 0;
  var SATURDAY = 6;
  var CUTOFF_WEEKDAY = 780; /* 1:00 PM en minutos */
  var CUTOFF_SATURDAY = 840; /* 2:00 PM */
  var HORIZON_DAYS = 60;

  /* 'YYYY-MM-DD' -> dia de la semana (0 = domingo), estable en cualquier TZ */
  function weekdayOf(iso) {
    return new Date(iso + 'T12:00:00Z').getUTCDay();
  }

  function addDays(iso, n) {
    var d = new Date(iso + 'T12:00:00Z');
    d.setUTCDate(d.getUTCDate() + n);
    return d.toISOString().slice(0, 10);
  }

  function cutoffFor(weekday) {
    if (weekday === SUNDAY) return null;
    if (weekday === SATURDAY) return CUTOFF_SATURDAY;
    return CUTOFF_WEEKDAY;
  }

  /* now = { date: 'YYYY-MM-DD', minutes: 0-1439 } en hora de Puerto Rico */
  function computeWindow(now) {
    var weekday = weekdayOf(now.date);
    var cutoff = cutoffFor(weekday);
    var todayAllowed = cutoff !== null && now.minutes < cutoff;
    var min = todayAllowed ? now.date : addDays(now.date, 1);
    while (weekdayOf(min) === SUNDAY) {
      min = addDays(min, 1);
    }
    return {
      min: min,
      max: addDays(now.date, HORIZON_DAYS),
      todayAllowed: todayAllowed,
      closedToday: cutoff === null,
      cutoffLabel: weekday === SATURDAY ? '2:00 PM' : '1:00 PM'
    };
  }

  function isSelectable(iso, win) {
    return weekdayOf(iso) !== SUNDAY && iso >= win.min && iso <= win.max;
  }

  /* Date del navegador -> partes en hora de Puerto Rico */
  function nowInPR(date) {
    var parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: TZ,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23'
    }).formatToParts(date);
    var p = {};
    parts.forEach(function (x) {
      p[x.type] = x.value;
    });
    return {
      date: p.year + '-' + p.month + '-' + p.day,
      minutes: Number(p.hour) * 60 + Number(p.minute)
    };
  }

  /* hora inyectada: ?fd_now=YYYY-MM-DDTHH:MM (hora de PR) o window.FD_NOW */
  function injectedNow(search, override) {
    var raw = override || null;
    if (!raw && search) {
      var m = /[?&]fd_now=(\d{4}-\d{2}-\d{2}T\d{2}:\d{2})/.exec(search);
      if (m) raw = m[1];
    }
    if (!raw) return null;
    return {
      date: raw.slice(0, 10),
      minutes: Number(raw.slice(11, 13)) * 60 + Number(raw.slice(14, 16))
    };
  }

  /* 'YYYY-MM-DD' -> 'Mon, Sep 14' en el idioma de la pagina */
  function formatDate(iso, lang) {
    try {
      return new Intl.DateTimeFormat(lang || 'en', {
        weekday: 'short',
        month: 'short',
        day: 'numeric',
        timeZone: 'UTC'
      }).format(new Date(iso + 'T12:00:00Z'));
    } catch (e) {
      return iso;
    }
  }

  return {
    computeWindow: computeWindow,
    isSelectable: isSelectable,
    weekdayOf: weekdayOf,
    addDays: addDays,
    nowInPR: nowInPR,
    injectedNow: injectedNow,
    formatDate: formatDate,
    SUNDAY: SUNDAY
  };
})();

if (typeof module !== 'undefined' && module.exports) {
  module.exports = FDDate;
}

(function () {
  'use strict';
  if (typeof document === 'undefined') return;

  function init(root) {
    if (root.dataset.fdReady === 'true') return;
    var input = root.querySelector('[data-fd-date]');
    if (!input) return;
    root.dataset.fdReady = 'true';

    var hint = root.querySelector('[data-fd-date-hint]');
    var errorBox = root.querySelector('[data-fd-date-error]');
    var t = root.dataset; /* textos de locale, sin apostrofes (regla del 7-sep) */
    var lang = document.documentElement.lang || 'en';

    var now =
      FDDate.injectedNow(window.location.search, window.FD_NOW) ||
      FDDate.nowInPR(new Date());
    var win = FDDate.computeWindow(now);
    var minLabel = FDDate.formatDate(win.min, lang);

    input.min = win.min;
    input.max = win.max;
    if (!input.value || !FDDate.isSelectable(input.value, win)) {
      input.value = win.min;
    }

    if (hint) {
      var text;
      if (win.todayAllowed) {
        text = t.fdHintSameDay.replace('[time]', win.cutoffLabel);
      } else if (win.closedToday) {
        text = t.fdHintSunday.replace('[date]', minLabel);
      } else {
        text = t.fdHintAfterCutoff
          .replace('[time]', win.cutoffLabel)
          .replace('[date]', minLabel);
      }
      hint.textContent = text;
    }

    function validateDate() {
      var v = input.value;
      var error = '';
      if (!v) {
        error = t.fdErrRequired;
      } else if (FDDate.weekdayOf(v) === FDDate.SUNDAY) {
        error = t.fdErrSunday;
      } else if (v < win.min || v > win.max) {
        error = t.fdErrRange.replace('[date]', minLabel);
      }
      input.setCustomValidity(error);
      if (errorBox) {
        errorBox.textContent = error;
        errorBox.hidden = !error;
      }
      return error === '';
    }

    input.addEventListener('change', validateDate);
    input.addEventListener('input', validateDate);
    validateDate();

    /* 23-oct (pedido #1015): al llegar al maxlength el navegador deja de escribir, y al pegar
       corta, sin decir nada. El contador enseña cuanto va y avisa al llegar al tope. */
    var count = root.querySelector('[data-fd-count]');
    var field = root.querySelector('[data-fd-count-field]');
    if (count && field && field.maxLength > 0) {
      var maxChars = field.maxLength;
      var updateCount = function () {
        var n = field.value.length;
        var full = n >= maxChars;
        count.textContent = (full ? count.dataset.fdCountFull : count.dataset.fdCountText)
          .split('[n]').join(n)
          .split('[max]').join(maxChars);
        count.classList.toggle('fd-order__count--near', !full && n >= maxChars * 0.9);
        count.classList.toggle('fd-order__count--full', full);
      };
      field.addEventListener('input', updateCount);
      updateCount();
    }

    /* El form de Dawn lleva novalidate y su JS no valida: la baranda va en el
       click del boton, que dispara antes que el submit del form. */
    var form = input.form;
    var button = form && form.querySelector('button[name="add"]');
    if (button) {
      button.addEventListener('click', function (evt) {
        validateDate();
        var fields = root.querySelectorAll('input, textarea');
        for (var i = 0; i < fields.length; i++) {
          if (!fields[i].checkValidity()) {
            evt.preventDefault();
            evt.stopImmediatePropagation();
            fields[i].reportValidity();
            return;
          }
        }
      });
    }
  }

  function boot() {
    var roots = document.querySelectorAll('[data-fd-order-fields]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
